import { c as _c } from "react/compiler-runtime";
import { Modal, ModalBody, ModalFooter, ModalFooterButton, ModalHeader, ModalHeaderTitle, TextBody } from "@opensea/ui-kit";
import { useMountEffect } from "@opensea/ui-kit/hooks";
import { head } from "es-toolkit/array";
import { useTranslations } from "use-intl";
import { useTrackEvent } from "../../providers/TrackEventProvider";
import { FlowState } from "../../stores/flowStore";
export function PriceChangeModal(t0) {
  const $ = _c(46);
  const {
    onConfirm,
    onCancel,
    priceValidation,
    symbol
  } = t0;
  const t = useTranslations("wallet.PriceChangeModal");
  const trackEvent = useTrackEvent();
  let t1;
  if ($[0] !== priceValidation || $[1] !== trackEvent) {
    t1 = () => {
      trackEvent("Modal Price Changed Warning Shown", {
        priceValidation,
        flow: FlowState.flow?.type
      });
    };
    $[0] = priceValidation;
    $[1] = trackEvent;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  useMountEffect(t1);
  let T0;
  let T1;
  let T2;
  let t2;
  let t3;
  let t4;
  if ($[3] !== priceValidation.changedItems || $[4] !== symbol || $[5] !== t) {
    const changedItem = head(priceValidation.changedItems);
    T2 = Modal;
    let t5;
    if ($[12] !== t) {
      t5 = t("title");
      $[12] = t;
      $[13] = t5;
    } else {
      t5 = $[13];
    }
    if ($[14] !== t5) {
      t4 = <ModalHeader><ModalHeaderTitle asChild={true}>{t5}</ModalHeaderTitle></ModalHeader>;
      $[14] = t5;
      $[15] = t4;
    } else {
      t4 = $[15];
    }
    T1 = ModalBody;
    T0 = TextBody;
    t2 = "text-secondary";
    t3 = t.rich("description", {
      initialPrice: changedItem?.initialPrice ?? 0,
      currentPrice: changedItem?.currentPrice ?? 0,
      priceDifferencePercentage: ((changedItem?.priceDifference ?? 0) / (changedItem?.initialPrice ?? 1) * 100).toFixed(2),
      symbol: symbol ?? "",
      Price: _temp,
      Difference: _temp2
    });
    $[3] = priceValidation.changedItems;
    $[4] = symbol;
    $[5] = t;
    $[6] = T0;
    $[7] = T1;
    $[8] = T2;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
  } else {
    T0 = $[6];
    T1 = $[7];
    T2 = $[8];
    t2 = $[9];
    t3 = $[10];
    t4 = $[11];
  }
  let t5;
  if ($[16] !== T0 || $[17] !== t2 || $[18] !== t3) {
    t5 = <T0 color={t2}>{t3}</T0>;
    $[16] = T0;
    $[17] = t2;
    $[18] = t3;
    $[19] = t5;
  } else {
    t5 = $[19];
  }
  let t6;
  if ($[20] !== T1 || $[21] !== t5) {
    t6 = <T1>{t5}</T1>;
    $[20] = T1;
    $[21] = t5;
    $[22] = t6;
  } else {
    t6 = $[22];
  }
  let t7;
  if ($[23] !== t) {
    t7 = t("cancel");
    $[23] = t;
    $[24] = t7;
  } else {
    t7 = $[24];
  }
  let t8;
  if ($[25] !== onCancel || $[26] !== t7) {
    t8 = <ModalFooterButton onClick={onCancel} variant="secondary">{t7}</ModalFooterButton>;
    $[25] = onCancel;
    $[26] = t7;
    $[27] = t8;
  } else {
    t8 = $[27];
  }
  let t9;
  if ($[28] !== t) {
    t9 = t("confirm");
    $[28] = t;
    $[29] = t9;
  } else {
    t9 = $[29];
  }
  let t10;
  if ($[30] !== onConfirm || $[31] !== t9) {
    t10 = <ModalFooterButton onClick={onConfirm} variant="warning">{t9}</ModalFooterButton>;
    $[30] = onConfirm;
    $[31] = t9;
    $[32] = t10;
  } else {
    t10 = $[32];
  }
  let t11;
  if ($[33] !== t10 || $[34] !== t8) {
    t11 = <ModalFooter>{t8}{t10}</ModalFooter>;
    $[33] = t10;
    $[34] = t8;
    $[35] = t11;
  } else {
    t11 = $[35];
  }
  let t12;
  if ($[36] !== t11 || $[37] !== t4 || $[38] !== t6) {
    t12 = <>{t4}{t6}{t11}</>;
    $[36] = t11;
    $[37] = t4;
    $[38] = t6;
    $[39] = t12;
  } else {
    t12 = $[39];
  }
  let t13;
  if ($[40] !== onCancel) {
    t13 = open => {
      if (!open) {
        onCancel();
      }
    };
    $[40] = onCancel;
    $[41] = t13;
  } else {
    t13 = $[41];
  }
  let t14;
  if ($[42] !== T2 || $[43] !== t12 || $[44] !== t13) {
    t14 = <T2 content={t12} onOpenChange={t13} open={true} />;
    $[42] = T2;
    $[43] = t12;
    $[44] = t13;
    $[45] = t14;
  } else {
    t14 = $[45];
  }
  return t14;
}
function _temp2(chunks_0) {
  return <TextBody color="warning">{chunks_0}</TextBody>;
}
function _temp(chunks) {
  return <TextBody color="text-primary" weight="semibold">{chunks}</TextBody>;
}